import React from 'react';
import { Link } from 'react-router-dom';
import { useCourses, Course } from '../../context/CourseContext';
import { BookOpen, CheckCircle } from 'lucide-react';
interface CourseCardProps {
  course: Course;
}
const CourseCard: React.FC<CourseCardProps> = ({
  course
}) => {
  const {
    isEnrolled,
    enrollInCourse
  } = useCourses();
  const enrolled = isEnrolled(course.id);
  const handleEnroll = (e: React.MouseEvent) => {
    e.preventDefault();
    enrollInCourse(course.id);
  };
  return <div className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300" data-id="element-100">
      <div className="relative h-48" data-id="element-101">
        <img src={course.thumbnail} alt={course.title} className="w-full h-full object-cover" data-id="element-102" />
        {course.isSuggested && <div className="absolute top-2 right-2 bg-yellow-400 text-xs font-semibold px-2 py-1 rounded-full text-gray-800" data-id="element-103">
            Suggested
          </div>}
        {!course.isRequired && !course.isSuggested && <div className="absolute top-2 right-2 bg-gray-200 text-xs font-semibold px-2 py-1 rounded-full text-gray-700" data-id="element-104">
            Optional
          </div>}
      </div>
      <div className="p-5" data-id="element-105">
        <h3 className="text-lg font-semibold text-gray-800 mb-2" data-id="element-106">
          {course.title}
        </h3>
        <p className="text-gray-600 text-sm mb-4 line-clamp-2" data-id="element-107">
          {course.description}
        </p>
        <div className="flex items-center text-gray-500 text-sm mb-4" data-id="element-108">
          <BookOpen size={16} className="mr-1" data-id="element-109" />
          <span data-id="element-110">
            {course.modules.length}{' '}
            {course.modules.length === 1 ? 'Module' : 'Modules'}
          </span>
        </div>
        {enrolled ? <Link to={`/courses/${course.id}`} className="flex items-center justify-center w-full bg-green-100 text-green-700 py-2 px-4 rounded-md font-medium hover:bg-green-200 transition-colors" data-id="element-111">
            <CheckCircle size={16} className="mr-2" data-id="element-112" />
            Continue Learning
          </Link> : <button onClick={handleEnroll} className="w-full bg-blue-600 text-white py-2 px-4 rounded-md font-medium hover:bg-blue-700 transition-colors" data-id="element-113">
            Enroll Now
          </button>}
      </div>
    </div>;
};
export default CourseCard;